import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from "react";
import { setFooterHeightStore } from "common-frontend-components";
import { useFooterStyles } from "../useFooterStyles";
export const FooterContainer = ({ ...props }) => {
    const classes = useFooterStyles();
    const ref = useRef(null);
    useEffect(() => {
        setFooterHeightStore({ footerHeight: (ref && ref.current && ref.current.clientHeight)
                ? ref.current.clientHeight
                : 0
        });
    });
    return (_jsx("div", { ref: ref, className: classes.footer, ...props }, void 0));
};
//# sourceMappingURL=FooterContainer.js.map